var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericProgressLinear',{attrs:{"icon":'mdi-chart-bar',"title":'Stats',"stats":_vm.stats}})}
var staticRenderFns = []

export { render, staticRenderFns }